import {
  getGochisData,
  getGenGochisData,
  updateGenGochisData,
  getGochisDataShop,
  getGochisDataEs,
  downloadGochiData,
  downloadGochiEsData,
  downloadGochiDataShop,
  getGochiDetailData,
  gochiImportFileData,
  deleteGochiData,
  sendReplyMessage,
  getGochiOneToNData,
  postRefund,
  changeTicketToNonUse,
  changeTicketToNTicket,
  sendShashokuReplyMessage,
  listBatchGochiChargeData,
  validateBatchGochiChargeData,
  batchGochiChargeImportFileData,
  adminUseGochiKidData,
  getListGochiKidUsedByAdminData,
  adminUseGochiKidGroupSpecialData,
  deleteCommentShashokuData,
  getGochiGroupCampaignData,
  downloadGochiGroupCampaignData,
  getUpdateAmountHistoryDetailData,
  getUpdateAmountHistoryListData,
  downloadUpdateAmountHistoryListData,
  updateAmountEducationSystemData,
  getRemainAmountUpdateAmountData,
  updateGochiKidReceiptFlagData,
  getListGochiKidUseData,
  unusedGochiKidData,
  getGochiGroupGochiKidData,
  downloadGochiGroupGochiKidData
} from '../libs/apis/GochiApi';

export const GET_GOCHIS_REQUEST = 'GET_GOCHIS_REQUEST';
export const GET_GOCHIS_SUCCESS = 'GET_GOCHIS_SUCCESS';
export const GET_GOCHIS_FAILURE = 'GET_GOCHIS_FAILURE';

export const GET_GOCHIS_SHOP_REQUEST = 'GET_GOCHIS_SHOP_REQUEST';
export const GET_GOCHIS_SHOP_SUCCESS = 'GET_GOCHIS_SHOP_SUCCESS';
export const GET_GOCHIS_SHOP_FAILURE = 'GET_GOCHIS_SHOP_FAILURE';

export const DOWNLOAD_GOCHIS_REQUEST = 'DOWNLOAD_GOCHIS_REQUEST';
export const DOWNLOAD_GOCHIS_SUCCESS = 'DOWNLOAD_GOCHIS_SUCCESS';
export const DOENLOAD_GOCHIS_FAILURE = 'DOENLOAD_GOCHIS_FAILURE';

export const DOWNLOAD_GOCHIS_ES_REQUEST = 'DOWNLOAD_GOCHIS_ES_REQUEST';
export const DOWNLOAD_GOCHIS_ES_SUCCESS = 'DOWNLOAD_GOCHIS_ES_SUCCESS';
export const DOENLOAD_GOCHIS_ES_FAILURE = 'DOENLOAD_GOCHIS_ES_FAILURE';

export const DOWNLOAD_GOCHIS_SHOP_REQUEST = 'DOWNLOAD_GOCHIS_SHOP_REQUEST';
export const DOWNLOAD_GOCHIS_SHOP_SUCCESS = 'DOWNLOAD_GOCHIS_SHOP_SUCCESS';
export const DOENLOAD_GOCHIS_SHOP_FAILURE = 'DOENLOAD_GOCHIS_SHOP_FAILURE';

export const GET_GOCHI_DETAIL_REQUEST = 'GET_GOCHI_DETAIL_REQUEST';
export const GET_GOCHI_DETAIL_SUCCESS = 'GET_GOCHI_DETAIL_SUCCESS';
export const GET_GOCHI_DETAIL_FAILURE = 'GET_GOCHI_DETAIL_FAILURE';

export const GET_GEN_GOCHI_REQUEST = 'GET_GEN_GOCHI_REQUEST';
export const GET_GEN_GOCHI_SUCCESS = 'GET_GEN_GOCHI_SUCCESS';
export const GET_GEN_GOCHI_FAILURE = 'GET_GEN_GOCHI_FAILURE';

export const UPDATE_GEN_GOCHI_REQUEST = 'UPDATE_GEN_GOCHI_REQUEST';
export const UPDATE_GEN_GOCHI_SUCCESS = 'UPDATE_GEN_GOCHI_SUCCESS';
export const UPDATE_GEN_GOCHI_FAILURE = 'UPDATE_GEN_GOCHI_FAILURE';

export const ADD_GOCHI_IMPORT_FILE_REQUEST = 'ADD_GOCHI_IMPORT_FILE_REQUEST';
export const ADD_GOCHI_IMPORT_FILE_SUCCESS = 'ADD_GOCHI_IMPORT_FILE_SUCCESS';
export const ADD_GOCHI_IMPORT_FILE_FAILURE = 'ADD_GOCHI_IMPORT_FILE_FAILURE';
export const SHOP_REPLY_REQUEST = 'SHOP_REPLY_REQUEST';
export const SHOP_REPLY_SUCCESS = 'SHOP_REPLY_SUCCESS';
export const SHOP_REPLY_FAILURE = 'SHOP_REPLY_FAILURE';

export const DELETE_GOCHI_REQUEST = 'DELETE_GOCHI_REQUEST';
export const DELETE_GOCHI_SUCCESS = 'DELETE_GOCHI_SUCCESS';
export const DELETE_GOCHI_FAILURE = 'DELETE_GOCHI_FAILURE';

export const GET_GOCHI_ONE_TO_N_REQUEST = 'GET_GOCHI_ONE_TO_N_REQUEST';
export const GET_GOCHI_ONE_TO_N_SUCCESS = 'GET_GOCHI_ONE_TO_N_SUCCESS';
export const GET_GOCHI_ONE_TO_N_FAILURE = 'GET_GOCHI_ONE_TO_N_FAILURE';

export const POST_REFUND_REQUEST = 'POST_REFUND_REQUEST';
export const POST_REFUND_SUCCESS = 'POST_REFUND_SUCCESS';
export const POST_REFUND_FAILURE = 'POST_REFUND_FAILURE';

export const CHANGE_TICKE_TO_NON_USE_REQUEST =
  'CHANGE_TICKE_TO_NON_USE_REQUEST';
export const CHANGE_TICKE_TO_NON_USE_SUCCESS =
  'CHANGE_TICKE_TO_NON_USE_SUCCESS';
export const CHANGE_TICKE_TO_NON_USE_FAILURE =
  'CHANGE_TICKE_TO_NON_USE_FAILURE';

export const CHANGE_TICKET_TO_N_REQUEST = 'CHANGE_TICKET_TO_N_REQUEST';
export const CHANGE_TICKET_TO_N_SUCCESS = 'CHANGE_TICKET_TO_N_SUCCESS';
export const CHANGE_TICKET_TO_N_FAILURE = 'CHANGE_TICKET_TO_N_FAILURE';

export const SHASHOKU_SHOP_REPLY_REQUEST = 'SHASHOKU_SHOP_REPLY_N_REQUEST';
export const SHASHOKU_SHOP_REPLY_SUCCESS = 'SHASHOKU_SHOP_REPLY_SUCCESS';
export const SHASHOKU_SHOP_REPLY_FAILURE = 'SHASHOKU_SHOP_REPLY_FAILURE';

export const GET_BATCH_GOCHI_CHARGE_REQUEST = 'GET_BATCH_GOCHI_CHARGE_REQUEST';
export const GET_BATCH_GOCHI_CHARGE_SUCCESS = 'GET_BATCH_GOCHI_CHARGE_SUCCESS';
export const GET_BATCH_GOCHI_CHARGE_FAILURE = 'GET_BATCH_GOCHI_CHARGE_FAILURE';

export const VALIDATE_BATCH_GOCHI_CHARGE_REQUEST =
  'VALIDATE_BATCH_GOCHI_CHARGE_REQUEST';
export const VALIDATE_BATCH_GOCHI_CHARGE_SUCCESS =
  'VALIDATE_BATCH_GOCHI_CHARGE_SUCCESS';
export const VALIDATE_BATCH_GOCHI_CHARGE_FAILURE =
  'VALIDATE_BATCH_GOCHI_CHARGE_FAILURE';

export const ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_REQUEST =
  'ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_REQUEST';
export const ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_SUCCESS =
  'ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_SUCCESS';
export const ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_FAILURE =
  'ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_FAILURE';

export const ADMIN_USE_GOCHI_KID_REQUEST = 'ADMIN_USE_GOCHI_KID_REQUEST';
export const ADMIN_USE_GOCHI_KID_SUCCESS = 'ADMIN_USE_GOCHI_KID_SUCCESS';
export const ADMIN_USE_GOCHI_KID_FAILURE = 'ADMIN_USE_GOCHI_KID_FAILURE';

export const GET_LIST_GOCHI_KID_USED_BY_ADMIN_REQUEST =
  'GET_LIST_GOCHI_KID_USED_BY_ADMIN_REQUEST';
export const GET_LIST_GOCHI_KID_USED_BY_ADMIN_SUCCESS =
  'GET_LIST_GOCHI_KID_USED_BY_ADMIN_SUCCESS';
export const GET_LIST_GOCHI_KID_USED_BY_ADMIN_FAILURE =
  'GET_LIST_GOCHI_KID_USED_BY_ADMIN_FAILURE';

export const ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_REQUEST =
  'ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_REQUEST';
export const ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_SUCCESS =
  'ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_SUCCESS';
export const ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_FAILURE =
  'ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_FAILURE';

export const DELETE_COMMENT_SHASHOKU_REQUEST =
  'DELETE_COMMENT_SHASHOKU_REQUEST';

export const DELETE_COMMENT_SHASHOKU_SUCCESS =
  'DELETE_COMMENT_SHASHOKU_SUCCESS';

export const DELETE_COMMENT_SHASHOKU_FAILURE =
  'DELETE_COMMENT_SHASHOKU_FAILURE';

export const GET_UPDATE_AMOUNT_HISTORY_DETAIL_REQUEST =
  'GET_UPDATE_AMOUNT_HISTORY_DETAIL_REQUEST';
export const GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS =
  'GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS';
export const GET_UPDATE_AMOUNT_HISTORY_DETAIL_FAILURE =
  'GET_UPDATE_AMOUNT_HISTORY_DETAIL_FAILURE';

export const GET_UPDATE_AMOUNT_HISTORY_LIST_REQUEST =
  'GET_UPDATE_AMOUNT_HISTORY_LIST_REQUEST';
export const GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS =
  'GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS';
export const GET_UPDATE_AMOUNT_HISTORY_LIST_FAILURE =
  'GET_UPDATE_AMOUNT_HISTORY_LIST_FAILURE';

export const DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_REQUEST =
  'DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_REQUEST';
export const DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS =
  'DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS';
export const DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_FAILURE =
  'DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_FAILURE';

export const UPDATE_AMOUNT_EDUCATION_SYSTEM_REQUEST =
  'UPDATE_AMOUNT_EDUCATION_SYSTEM_REQUEST';
export const UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS =
  'UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS';
export const UPDATE_AMOUNT_EDUCATION_SYSTEM_FAILURE =
  'UPDATE_AMOUNT_EDUCATION_SYSTEM_FAILURE';

export const GET_REMAIN_AMOUNT_UPDATE_AMOUNT_REQUEST =
  'GET_REMAIN_AMOUNT_UPDATE_AMOUNT_REQUEST';
export const GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS =
  'GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS';
export const GET_REMAIN_AMOUNT_UPDATE_AMOUNT_FAILURE =
  'GET_REMAIN_AMOUNT_UPDATE_AMOUNT_FAILURE';

export const UPDATE_GOCHI_KID_RECEIPT_FLAG_REQUEST =
  'UPDATE_GOCHI_KID_RECEIPT_FLAG_REQUEST';
export const UPDATE_GOCHI_KID_RECEIPT_FLAG_SUCCESS =
  'UPDATE_GOCHI_KID_RECEIPT_FLAG_SUCCESS';
export const UPDATE_GOCHI_KID_RECEIPT_FLAG_FAILURE =
  'UPDATE_GOCHI_KID_RECEIPT_FLAG_FAILURE';

export const GET_LIST_GOCHI_KID_USE_REQUEST = 'GET_LIST_GOCHI_KID_USE_REQUEST';
export const GET_LIST_GOCHI_KID_USE_SUCCESS = 'GET_LIST_GOCHI_KID_USE_SUCCESS';
export const GET_LIST_GOCHI_KID_USE_FAILURE = 'GET_LIST_GOCHI_KID_USE_FAILURE';

export const UNUSED_GOCHI_KID_REQUEST = 'UNUSED_GOCHI_KID_REQUEST';
export const UNUSED_GOCHI_KID_SUCCESS = 'UNUSED_GOCHI_KID_SUCCESS';
export const UNUSED_GOCHI_KID_FAILURE = 'UNUSED_GOCHI_KID_FAILURE';

export const getGochis = params => dispatch => {
  dispatch({ type: GET_GOCHIS_REQUEST });
  return getGochisData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHIS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHIS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGenGochis = params => dispatch => {
  dispatch({ type: GET_GEN_GOCHI_REQUEST });
  return getGenGochisData(params)
    .then(response =>
      dispatch({
        type: GET_GEN_GOCHI_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GEN_GOCHI_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateGenGochis = params => dispatch => {
  dispatch({ type: UPDATE_GEN_GOCHI_REQUEST });
  return updateGenGochisData(params)
    .then(response =>
      dispatch({
        type: UPDATE_GEN_GOCHI_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_GEN_GOCHI_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochisShop = params => dispatch => {
  dispatch({ type: GET_GOCHIS_SHOP_REQUEST });
  return getGochisDataShop(params)
    .then(response =>
      dispatch({
        type: GET_GOCHIS_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHIS_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const postShopReply = params => dispatch => {
  dispatch({ type: SHOP_REPLY_REQUEST });
  return sendReplyMessage(params)
    .then(response =>
      dispatch({
        type: SHOP_REPLY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SHOP_REPLY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGochi = params => dispatch => {
  dispatch({ type: DOWNLOAD_GOCHIS_REQUEST });
  return downloadGochiData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GOCHIS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOENLOAD_GOCHIS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGochiEs = params => dispatch => {
  dispatch({ type: DOWNLOAD_GOCHIS_ES_REQUEST });
  return downloadGochiEsData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GOCHIS_ES_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOENLOAD_GOCHIS_ES_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGochiShop = params => dispatch => {
  dispatch({ type: DOWNLOAD_GOCHIS_SHOP_REQUEST });
  return downloadGochiDataShop(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GOCHIS_SHOP_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOENLOAD_GOCHIS_SHOP_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiDetail = couponId => dispatch => {
  dispatch({ type: GET_GOCHI_DETAIL_REQUEST });
  return getGochiDetailData(couponId)
    .then(response =>
      dispatch({
        type: GET_GOCHI_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const gochiImportFile = params => dispatch => {
  dispatch({ type: ADD_GOCHI_IMPORT_FILE_REQUEST });
  return gochiImportFileData(params)
    .then(response =>
      dispatch({
        type: ADD_GOCHI_IMPORT_FILE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_GOCHI_IMPORT_FILE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteGochi = menuId => dispatch => {
  dispatch({ type: DELETE_GOCHI_REQUEST });
  return deleteGochiData(menuId)
    .then(response =>
      dispatch({
        type: DELETE_GOCHI_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_GOCHI_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochisEs = params => dispatch => {
  dispatch({ type: GET_GOCHIS_REQUEST });
  return getGochisDataEs(params)
    .then(response =>
      dispatch({
        type: GET_GOCHIS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHIS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiOneToN = params => dispatch => {
  dispatch({ type: GET_GOCHI_ONE_TO_N_REQUEST });
  return getGochiOneToNData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHI_ONE_TO_N_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHI_ONE_TO_N_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const postRefundData = params => dispatch => {
  dispatch({ type: POST_REFUND_REQUEST });
  return postRefund(params)
    .then(response =>
      dispatch({
        type: POST_REFUND_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: POST_REFUND_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const divideTicketToNTicket = params => dispatch => {
  dispatch({ type: CHANGE_TICKET_TO_N_REQUEST });
  return changeTicketToNTicket(params)
    .then(response =>
      dispatch({
        type: CHANGE_TICKET_TO_N_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CHANGE_TICKET_TO_N_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const switchTicketToNonUse = params => dispatch => {
  dispatch({ type: CHANGE_TICKE_TO_NON_USE_REQUEST });
  return changeTicketToNonUse(params)
    .then(response =>
      dispatch({
        type: CHANGE_TICKE_TO_NON_USE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: CHANGE_TICKE_TO_NON_USE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const postShashokuShopReply = params => dispatch => {
  dispatch({ type: SHASHOKU_SHOP_REPLY_REQUEST });
  return sendShashokuReplyMessage(params)
    .then(response =>
      dispatch({
        type: SHASHOKU_SHOP_REPLY_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: SHASHOKU_SHOP_REPLY_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const listBatchGochiCharge = params => dispatch => {
  dispatch({ type: GET_BATCH_GOCHI_CHARGE_REQUEST });
  return listBatchGochiChargeData(params)
    .then(response =>
      dispatch({
        type: GET_BATCH_GOCHI_CHARGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_BATCH_GOCHI_CHARGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const validateBatchGochiCharge = params => dispatch => {
  dispatch({ type: VALIDATE_BATCH_GOCHI_CHARGE_REQUEST });
  return validateBatchGochiChargeData(params)
    .then(response =>
      dispatch({
        type: VALIDATE_BATCH_GOCHI_CHARGE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: VALIDATE_BATCH_GOCHI_CHARGE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const batchGochiChargeImportFile = params => dispatch => {
  dispatch({ type: ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_REQUEST });
  return batchGochiChargeImportFileData(params)
    .then(response =>
      dispatch({
        type: ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADD_BATCH_GOCHI_CHARGE_IMPORT_FILE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const adminUseGochiKid = params => dispatch => {
  dispatch({ type: ADMIN_USE_GOCHI_KID_REQUEST });
  return adminUseGochiKidData(params)
    .then(response =>
      dispatch({
        type: ADMIN_USE_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADMIN_USE_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const adminUseGochiKidGroupSpecial = params => dispatch => {
  dispatch({ type: ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_REQUEST });
  return adminUseGochiKidGroupSpecialData(params)
    .then(response =>
      dispatch({
        type: ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: ADMIN_USE_GOCHI_KID_GROUP_SPECIAL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getListGochiKidUsedByAdmin = params => dispatch => {
  dispatch({ type: GET_LIST_GOCHI_KID_USED_BY_ADMIN_REQUEST });
  return getListGochiKidUsedByAdminData(params)
    .then(response =>
      dispatch({
        type: GET_LIST_GOCHI_KID_USED_BY_ADMIN_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_LIST_GOCHI_KID_USED_BY_ADMIN_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const deleteCommentShashoku = params => dispatch => {
  dispatch({ type: DELETE_COMMENT_SHASHOKU_REQUEST });
  return deleteCommentShashokuData(params)
    .then(response =>
      dispatch({
        type: DELETE_COMMENT_SHASHOKU_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DELETE_COMMENT_SHASHOKU_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiGroupCampaign = params => dispatch => {
  dispatch({ type: GET_GOCHIS_REQUEST });
  return getGochiGroupCampaignData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHIS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHIS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGochiGroupCampaign = params => dispatch => {
  dispatch({ type: DOWNLOAD_GOCHIS_REQUEST });
  return downloadGochiGroupCampaignData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GOCHIS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOENLOAD_GOCHIS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getUpdateAmountHistoryDetail = params => dispatch => {
  dispatch({ type: GET_UPDATE_AMOUNT_HISTORY_DETAIL_REQUEST });
  return getUpdateAmountHistoryDetailData(params)
    .then(response =>
      dispatch({
        type: GET_UPDATE_AMOUNT_HISTORY_DETAIL_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_UPDATE_AMOUNT_HISTORY_DETAIL_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getUpdateAmountHistoryList = params => dispatch => {
  dispatch({ type: GET_UPDATE_AMOUNT_HISTORY_LIST_REQUEST });
  return getUpdateAmountHistoryListData(params)
    .then(response =>
      dispatch({
        type: GET_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_UPDATE_AMOUNT_HISTORY_LIST_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadUpdateAmountHistoryList = params => dispatch => {
  dispatch({ type: DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_REQUEST });
  return downloadUpdateAmountHistoryListData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOWNLOAD_UPDATE_AMOUNT_HISTORY_LIST_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getRemainAmountUpdateAmount = params => dispatch => {
  dispatch({ type: GET_REMAIN_AMOUNT_UPDATE_AMOUNT_REQUEST });
  return getRemainAmountUpdateAmountData(params)
    .then(response =>
      dispatch({
        type: GET_REMAIN_AMOUNT_UPDATE_AMOUNT_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_REMAIN_AMOUNT_UPDATE_AMOUNT_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateAmountEducationSystem = (params, crfsToken) => dispatch => {
  dispatch({ type: UPDATE_AMOUNT_EDUCATION_SYSTEM_REQUEST });
  return updateAmountEducationSystemData(params, crfsToken)
    .then(response =>
      dispatch({
        type: UPDATE_AMOUNT_EDUCATION_SYSTEM_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_AMOUNT_EDUCATION_SYSTEM_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const updateGochiKidReceiptFlag = params => dispatch => {
  dispatch({ type: UPDATE_GOCHI_KID_RECEIPT_FLAG_REQUEST });
  return updateGochiKidReceiptFlagData(params)
    .then(response =>
      dispatch({
        type: UPDATE_GOCHI_KID_RECEIPT_FLAG_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UPDATE_GOCHI_KID_RECEIPT_FLAG_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getListGochiKidUse = params => dispatch => {
  dispatch({ type: GET_LIST_GOCHI_KID_USE_REQUEST });
  return getListGochiKidUseData(params)
    .then(response =>
      dispatch({
        type: GET_LIST_GOCHI_KID_USE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_LIST_GOCHI_KID_USE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const unusedGochiKid = params => dispatch => {
  dispatch({ type: UNUSED_GOCHI_KID_REQUEST });
  return unusedGochiKidData(params)
    .then(response =>
      dispatch({
        type: UNUSED_GOCHI_KID_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: UNUSED_GOCHI_KID_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const getGochiGroupGochiKid = params => dispatch => {
  dispatch({ type: GET_GOCHIS_REQUEST });
  return getGochiGroupGochiKidData(params)
    .then(response =>
      dispatch({
        type: GET_GOCHIS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GET_GOCHIS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};

export const downloadGochiGroupGochiKid = params => dispatch => {
  dispatch({ type: DOWNLOAD_GOCHIS_REQUEST });
  return downloadGochiGroupGochiKidData(params)
    .then(response =>
      dispatch({
        type: DOWNLOAD_GOCHIS_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: DOENLOAD_GOCHIS_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
